import React, { useState, useRef, useEffect } from 'react';
import CustomButton from '../../components/CustomButton';
import Color from '../../../utils/Color';
import CustomText, {
  getFontSize,
  getFontWeight
} from '../../components/CustomText';
import './OTPInput.css';
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import { useHistory } from 'react-router-dom';
import CustomBoardNewLogin from '../../components/CustomBoardNewLogin';
import * as selector from '../../../common/selectors';
import * as regAction from '../../../common/actions/registration';
import AuthManager from '../../../utils/AuthManager';
import { useSelector, useDispatch } from 'react-redux';
import CustomToast from '../../components/CustomToast';
import LoadingOverlay from '../../components/LoadingOverlay';
import { Grid } from '@material-ui/core';
import CustomModal from '../../components/CustomModal';
import Image from "../../../assets";
import ContactModal from './ContactPopUp';
// -------------------------------------
// 1) useStyles with breakpoints for responsiveness
// -------------------------------------
const useStyles = makeStyles((theme) => ({
  container: {
    // Default (desktop) padding
    paddingTop: "3.5rem",
    paddingLeft: '2.2rem',
    paddingRight: '2.2rem',
    [theme.breakpoints.down('sm')]: {
      // Tighter padding on mobile
      paddingTop: "0rem",
      paddingLeft: '1rem',
      paddingRight: '1rem',
      paddingBottom: '2rem'
    },
  },
  headerTextStyle: {
    fontWeight: 700,
    fontSize: 20,
    color: "#333333",
    [theme.breakpoints.down('sm')]: {
      // Slightly smaller on mobile
      fontSize: 18,
    },
    marginTop: 20
  },
  subHeaderText: {
    fontWeight: 500,
    fontSize: 14,
    color: '#333333',
    marginTop: '0.6rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: 13,
    },
  },
  otpContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '13px',
    justifyContent: 'flex-start',
    marginTop: '2.5rem',
    [theme.breakpoints.down('xs')]: {
      gap: '11px',
    },
  },
  otpInput: {
    textAlign: 'center',
    fontSize: '16px',
    width: '48px',
    height: '58px',
    border: '1px solid #C6C7C9',
    [theme.breakpoints.down('xs')]: {
      // Slightly shrink on very small screens
      width: '37px',
      height: '50px',
    },
    borderRadius: '8px',
    '&:focus': {
      outline: 'none',
      border: '2px solid #0EA5E9'
    }
  },
  resendText: {
    color: '#0D99FF',
    // textDecoration: 'underline',
    fontSize: '12px',
    cursor: 'pointer',
    marginTop: '1rem',
    fontWeight: 500,
    marginLeft: '0.3rem'
  },
  resendTextV1: {
    color: 'rgba(112, 112, 112, 1)',
    fontSize: '12px',
    cursor: 'pointer',
    marginTop: '1rem',
    fontWeight: 500,
  },
  buttonStyle: {
    height: '48px',
    [theme.breakpoints.down('sm')]: {
      height: '45px',
    },
    [theme.breakpoints.up("lg")]: {
      minWidth: 496,
      maxWidth: 496,
      left: '-3.4rem',
    },
    [theme.breakpoints.down("sm")]: {
      minWidth: 410,
      maxWidth: 410,
      // left: '-3.4rem',
    },

    [theme.breakpoints.down('xs')]: {
      minWidth: '100%',
      maxWidth: '100%',
      left: 0,
    }
  },
  helpText: {
    marginTop: '3.5rem',
    fontSize: '12px',
    color: '#818181',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      marginTop: '2rem',
      fontSize: '11px',
    },
  },
  modalDesign: {
    padding: 0,
    textAlign: 'center',
    paddingLeft: 15,
    paddingRight: 15,
    paddingBottom: 5,
    [theme.breakpoints.down("xs")]: {
      minWidth: 200,
      marginTop: 20,
      marginBottom: 20,
    },
    [theme.breakpoints.up("sm")]: {
      minWidth: 250,
    },
    [theme.breakpoints.up("lg")]: {
      minWidth: 250,
      maxWidth: 250,
    },
    textInputStyle: {
      height: 35,
      marginLeft: 5,
      marginRight: 5,
    },
    containerStyle: {
      flexGrow: 1,
      marginBottom: 30,
      paddingRight: 20,
      marginBottom: 30
    },
    tooltipContainer: {
      display: "flex",
      alignItems: "center",
    },
    titleTextStyle: {
      fontWeight: 'bold',
      fontSize: 25,
    },
  },
}));
// -------------------------------------
// Main Component
// -------------------------------------
const MobileOtpNew = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  // 2) OTP input states
  const [otpValues, setOtpValues] = useState(['', '', '', '', '', '']);
  const [currentFocus, setCurrentFocus] = useState(0);
  const inputRefs = useRef([]);
  // 3) Extra states for logic
  const [resendOtp, setResendOtp] = useState(false);
  const [verifyOTPAction, setVerifyOTPAction] = useState(false);
  const [customToastStatus, setCustomToastStatus] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [localOtpRef, setLocalOtpRef] = useState('');
  const [localOtp, setLocalOtp] = useState('');
  const [localClientMobile, setLocalClientMobile] = useState('');
  const [localClientMobileLast4Digits, setLocalClientMobileLast4Digits] = useState('');
  const [asterisks, setAsterisks] = useState('');
  const [isVisible, setIsVisible] = useState(false);
  const [otpCountDown, setOtpCountDown] = useState(60);
  const timerRef = useRef(null);
  const [isVisibleContactPop, setIsVisibleContactPop] = useState(false);
  const [registrationId, setRegistrationId] = useState('');
  const [smsConsent, setSmsConsent] = useState(false);
  const [phoneConsent, setPhoneConsent] = useState(false);
  const [emailConsent, setEmailConsent] = useState(false);
  const [calledApi, setCalledApi] = useState(false);
  // 4) Redux selectors
  const registrationOTPVerifyData = useSelector(selector.registrationOTPVerifyData);
  const registrationOTPVerifyLoading = useSelector(selector.registrationOTPVerifyLoading);
  const registrationOtpResendData = useSelector(selector.registrationOtpResendData);
  const registrationOtpResendLoading = useSelector(selector.registrationOtpResendLoading);
  const getRegistrationCustomerDetailsData = useSelector(selector.getRegistrationCustomerDetailsData);
  const getRegistrationCustomerDetailsLoading = useSelector(selector.getRegistrationCustomerDetailsLoading);
  const getRegistrationCustomerDetailsStatus = useSelector(selector.getRegistrationCustomerDetailsStatus);
  const generateOTPOnboardingData = useSelector(selector.generateOTPOnboardingData);
  const generateOTPOnboardingLoading = useSelector(selector.generateOTPOnboardingLoading);
  const registerNewCustomerv2Data = useSelector(selector.registerNewCustomerv2Data);
  const registerNewCustomerv2Loading = useSelector(selector.registerNewCustomerv2Loading);
  const getLoginTokenData = useSelector(selector.getLoginTokenData);
  const getLoginTokenLoading = useSelector(selector.getLoginTokenLoading);
  const getRegistrationCustomerInfoData = useSelector(selector.getRegistrationCustomerInfoData);
  // -------------------------------------
  // Focus correct input whenever currentFocus changes
  // -------------------------------------
  useEffect(() => {
    if (inputRefs.current[currentFocus]) {
      inputRefs.current[currentFocus].focus();
    }
  }, [currentFocus]);
  const startTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
    setOtpCountDown(60);
    timerRef.current = setInterval(() => {
      setOtpCountDown((prev) => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          timerRef.current = null;
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };
  useEffect(() => {
    startTimer();
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    return () => {
      // Cleanup on unmount
      setCalledApi(false)
      localStorage.removeItem("localFullName")
    };
  }, []);

  // -------------------------------------
  // Retrieve consents from localStorage
  // -------------------------------------
  // useEffect(() => {
  //   setSmsConsent(localStorage.getItem('smsConsent') === 'true');
  //   setPhoneConsent(localStorage.getItem('phoneConsent') === 'true');
  //   setEmailConsent(localStorage.getItem('emailConsent') === 'true');
  //   const regId = localStorage.getItem('registrationId'); // Assuming stored from previous page
  //   if (regId) {
  //     setRegistrationId(regId);
  //     dispatch(regAction.generateOTPOnboarding({ RegistrationId: regId }));
  //   }
  // }, [dispatch]);
  useEffect(() => {
    setSmsConsent(localStorage.getItem('smsConsent') === 'true');
    setPhoneConsent(localStorage.getItem('phoneConsent') === 'true');
    setEmailConsent(localStorage.getItem('emailConsent') === 'true');
    const regId = localStorage.getItem('registrationId'); // Assuming stored from previous page
    if (regId) {
      setRegistrationId(regId);
      // Integrate reCAPTCHA logic before dispatching OTP generation
      const handleOTPGeneration = async () => {
        try {
          // Call reCAPTCHA API to get the token
          const recaptchaToken = await window.grecaptcha.execute(
            "6Lce7OMZAAAAALxOm9WwIETw1EL9UB73SDe4g0Tx",
            { action: "WEB_REGISTRATION_UPLOAD_OCR" }
          );

          if (!recaptchaToken) {
            setCustomToastStatus(true);
            setToastMessage("Unable to verify reCAPTCHA. Please try again.");
            return;
          }

          // Dispatch with both RegistrationId and RecaptchaToken
          dispatch(regAction.generateOTPOnboarding({
            RegistrationId: regId,
            RecaptchaToken: recaptchaToken
          }));
        } catch (error) {
          setCustomToastStatus(true);
          setToastMessage("Error during reCAPTCHA verification. Please try again.");
        }
      };

      handleOTPGeneration();
    }
  }, [dispatch]);
  // -------------------------------------
  // Handle getRegistrationCustomerInfoData for masked mobile
  // -------------------------------------
  useEffect(() => {
    if (getRegistrationCustomerInfoData?.Data) {
      const maskedMobile = getRegistrationCustomerInfoData.Data.MaskedMobile;
      if (maskedMobile) {
        setLocalClientMobile(maskedMobile);
        const last4 = maskedMobile.slice(-4);
        setLocalClientMobileLast4Digits(last4);
        const asteriskCount = Math.max(maskedMobile.length - 4, 0);
        setAsterisks('*'.repeat(asteriskCount));
      }
    }
  }, [getRegistrationCustomerInfoData]);
  // -------------------------------------
  // Handle generateOTPOnboarding response
  // -------------------------------------
  useEffect(() => {
    if (generateOTPOnboardingData && !generateOTPOnboardingLoading) {
      if (generateOTPOnboardingData.Success) {
        const data = generateOTPOnboardingData.Data;
        setLocalOtpRef(data.ReferenceNumber || '');
        if (data.MaskedMobile) {
          setLocalClientMobile(data.MaskedMobile);
          const last4 = data.MaskedMobile.slice(-4);
          setLocalClientMobileLast4Digits(last4);
          const asteriskCount = Math.max(data.MaskedMobile.length - 4, 0);
          setAsterisks('*'.repeat(asteriskCount));
        }
        startTimer();
      } else {
        setCustomToastStatus(true);
        setToastMessage(generateOTPOnboardingData.Message || 'Failed to generate OTP. Please try again.');
      }
    }
  }, [generateOTPOnboardingData]);
  // -------------------------------------
  // Handle registerNewCustomerv2 response
  // -------------------------------------
  useEffect(() => {
    if (registerNewCustomerv2Data && calledApi) {
      setCalledApi(false);
      if (registerNewCustomerv2Data.Success && registerNewCustomerv2Data.Data.Status === "SUCCESS") {
        const formTypeId = getRegistrationCustomerInfoData?.Data?.RegistrationFormTypeId;
        if (formTypeId === 5 || formTypeId === 6 || formTypeId === 7) {
          // Singpass-origin flow: login directly
          dispatch(regAction.getLoginToken({ RegistrationId: registrationId }));
          setCalledApi(true)
        } else {
          // Non-Singpass flow: proceed to create User ID & Password
          history.push('/CreateUserIDPass');
        }
      } else {
        //history.push('/OnboardingErr'); // Redirect to error page on FAIL
        setCustomToastStatus(true);
        setToastMessage(registerNewCustomerv2Data.Data.ErrorMessage || 'Registration failed. Please try again.');
      }
    }
  }, [registerNewCustomerv2Data]);
  // -------------------------------------
  // Handle getLoginToken response
  // -------------------------------------
  useEffect(() => {
    if (getLoginTokenData && calledApi) {
      setCalledApi(false);
      if (getLoginTokenData.Success) {
        const formTypeId = getRegistrationCustomerInfoData?.Data?.RegistrationFormTypeId;
        const loginData = getLoginTokenData.Data;
        const errorMsg = loginData.error_message;
        const token = loginData.token;
        const needSetUserID = loginData.need_set_user_id;
        const isMasterAccount = loginData.is_master_account;
        const sessionExpiryWarning = loginData.session_expiry_warning;
        const sessionExpiryEnd = loginData.session_expiry_end;
        const isDirectClient = loginData.direct_client;
        const sessionId = loginData.session_id;
        if (!errorMsg) {
          AuthManager.setToken(token);
          AuthManager.setSetChangeUserID(needSetUserID);
          AuthManager.setIsMasterAccount(isMasterAccount);
          AuthManager.setDirectClient(isDirectClient);
          AuthManager.setSessionID(sessionId);
          AuthManager.setExpiryWarning(sessionExpiryWarning);
          AuthManager.setExpiryEnd(sessionExpiryEnd);
          window.location.href = process.env.REACT_APP_TIQ_BASE_URL;
          formTypeId !== 5 && localStorage.setItem("IsFirstTimeLogin", true)
        } else {
          history.push('/OnboardingErr');
          setCustomToastStatus(true);
          setToastMessage('Login failed. Please try again.');
        }
      } else {
        history.push('/OnboardingErr');
        setCustomToastStatus(true);
        setToastMessage(getLoginTokenData.Message || 'Failed to get login token. Please try again.');
      }
    }
  }, [getLoginTokenData]);
  const handleOpen = () => setIsVisibleContactPop(true);
  const handleClose = () => setIsVisibleContactPop(false);
  // -------------------------------------
  // OTP Input Handlers
  // -------------------------------------
  const handleInputChange = (index, value) => {
    let digit = value.replace(/\D/g, '').slice(-1);
    const newOtpValues = [...otpValues];
    newOtpValues[index] = digit;
    setOtpValues(newOtpValues);
    // Move to next input if a digit was entered and not on the last field
    if (digit && index < otpValues.length - 1) {
      setCurrentFocus(index + 1);
    }
  };
  const handleKeyDown = (index, event) => {
    // Check for backspace
    if (event.key === 'Backspace') {
      if (!otpValues[index] && index > 0) {
        setCurrentFocus(index - 1);
      } else {
        const newOtpValues = [...otpValues];
        newOtpValues[index] = '';
        setOtpValues(newOtpValues);
      }
    }
  };
  // -------------------------------------
  // Resend OTP
  // -------------------------------------
  const onClickResend = async () => {
    try {
      // Call reCAPTCHA API to get the token
      const recaptchaToken = await window.grecaptcha.execute(
        "6Lce7OMZAAAAALxOm9WwIETw1EL9UB73SDe4g0Tx",
        { action: "WEB_REGISTRATION_SEND_OTP" }
      );
      if (!recaptchaToken) {
        setCustomToastStatus(true)
        setToastMessage("Unable to verify reCAPTCHA. Please try again.")
        return;
      }
      // Update resendOtp state
      setResendOtp(true);
      dispatch(regAction.generateOTPOnboarding({ RegistrationId: registrationId, RecaptchaToken:recaptchaToken }));
      // Restart the OTP countdown after successful reCAPTCHA and dispatch
      startTimer();
      setOtpValues(['', '', '', '', '', ''])
    } catch (error) {
      setCustomToastStatus(true)
      setToastMessage("Error during reCAPTCHA verification. Please try again.")
    }
  };
  // -------------------------------------
  // Register New Customer v2
  // -------------------------------------
  const onSubmitRegistration = () => {
    const code = otpValues.join('');
    if (!code) {
      setCustomToastStatus(true);
      setToastMessage('Please enter your OTP.');
      return;
    }
    const customerData = getRegistrationCustomerInfoData?.Data || {};
    const fullName = localStorage.getItem("localFullName") ? localStorage.getItem("localFullName") : customerData.Name;
    const finalOtpRef = localOtpRef || generateOTPOnboardingData?.Data?.ReferenceNumber;
    const payload = {
      "RegistrationId": registrationId,
      "FullName": fullName,
      "Otp": code,
      "OtpReference": finalOtpRef,
      "SmsConsent": smsConsent,
      "PhoneConsent": phoneConsent,
      "EmailConsent": emailConsent
    };
    dispatch(regAction.registerNewCustomerv2(payload));
    setCalledApi(true)
  };
  // -------------------------------------
  // Toast Handler
  // -------------------------------------
  const handleCloseCustomToast = (event, reason) => {
    if (reason === 'clickaway') return;
    setCustomToastStatus(false);
  };
  // -------------------------------------
  // Rendering the Page
  // -------------------------------------
  const renderPage = () => {
    return (
      <div className={classes.container}>
        <div style={{ display: 'flex', flexDirection: "row", justifyContent: 'center' }}><img src={Image.otpIcon} /></div>
        <div className={classes.headerTextStyle}>We’ve sent an OTP code to</div>
        <div className={classes.subHeaderText}>
          {`****${localClientMobileLast4Digits}`}
        </div>
        <div className={classes.otpContainer}>
          {otpValues.map((val, index) => (
            <input
              key={index}
              ref={(el) => (inputRefs.current[index] = el)}
              type="text"
              maxLength={1}
              value={val}
              onChange={(e) => handleInputChange(index, e.target.value)}
              onKeyDown={(e) => handleKeyDown(index, e)}
              inputMode="numeric"
              className={classes.otpInput}
            />
          ))}
        </div>
        {/* Resend */}
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
          <span className={classes.resendTextV1}> Didn’t receive the OTP? </span>
          <span className={classes.resendText} onClick={otpCountDown < 1 ? onClickResend : null}>
            {otpCountDown > 0 ? `Resend in ${otpCountDown} sec` : 'Resend OTP'}
          </span>
        </div>
        <div style={{ marginTop: '2.5rem' }}>
          <CustomButton
            title="Verify"
            onClick={onSubmitRegistration}
            design={classes.buttonStyle}
          />
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: '2.5rem' }}>
          <span style={{ fontSize: '16px', color: 'rgba(0, 0, 0, 1)', fontWeight: 'bold' }}>Mobile No. incorrect?</span>
          <span style={{ fontSize: '16px', color: 'rgba(14, 165, 233, 1)', fontWeight: 'bold', marginLeft: '0.4rem', cursor: 'pointer' }} onClick={handleOpen}>Contact Us</span>
        </div>
        {/* <div className={classes.helpText}>
          If you encounter any issues, please contact our Customer Service Centre
          via our hotline +65 6887 8777 or WhatsApp us at +65 6887 8777
        </div> */}
      </div>
    );
  };
  const renderMaintenanceChild = () => <></>;
  const modalContainer = () => {
    return (
      <div className={classes.containerStyle}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div className={classes.tooltipContainer}>
              <CustomText design={classes.titleTextStyle} style={{ marginBottom: 10 }}>
                {getRegistrationCustomerDetailsData?.Data?.Message || getRegistrationCustomerDetailsData?.Data?.ErrorMessage || "You have entered an invalid OTP. Please try again."}
              </CustomText>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  };
  const onClickNextButton = () => {
    history.push("/")
  };
  // Dimensions for CustomBoardNewLogin
  const height = 800;
  const width = 600;
  return (
    <>
      <CustomBoardNewLogin
        maintenanceChild={renderMaintenanceChild()}
        children={renderPage()}
        height={height}
        width={width}
      />
      <CustomToast
        open={customToastStatus}
        handleCloseCustomToast={handleCloseCustomToast}
        title={toastMessage}
        warning
      />
      <CustomModal
        open={isVisible}
        //handleClose={handleClose}
        //titlestyle={classes.modalTitleStyle}
        modalDesign={classes.modalDesign}
        submitButtonText={"OK"}
        //cancelButtonText={"Cancel"}
        modalComponent={modalContainer()}
        disableBackdropClick
        handleSubmitButton={() => onClickNextButton()}
        isVisibleCloseButton={false}
        okBtnSty={true}
      // handleCancelButton={handleClose}
      />
      {(registrationOTPVerifyLoading
        || registrationOtpResendLoading
        || getRegistrationCustomerDetailsLoading
        || generateOTPOnboardingLoading
        || registerNewCustomerv2Loading
        || getLoginTokenLoading) && (
          <LoadingOverlay loading={true} />
        )}
      <ContactModal isVisible={isVisibleContactPop} onClose={handleClose} />
    </>
  );
};
export default MobileOtpNew;